module.exports = "/_next/static/images/PowerDeliveryHero-cab8a084d124d0478fda0469d64b522f.webp";